module.exports = __webpack_public_path__ + "media/images/front/treatment_support/neuromyelitis-optica/hint-modal01-a05339863075da52ee12c97c5b3a83cf.png";